import React from 'react';
import { ArrowRight, Mail, Phone, MapPin } from 'lucide-react';

const Footer = ({ onNavigate }) => {
  const handleNav = (page, sectionId) => (e) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate(page);
    }
    if (sectionId) {
      setTimeout(() => {
        const el = document.getElementById(sectionId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer-container" id="contact-footer">
      <div className="footer-main-wrapper">
        {/* 4 Columns Content Grid */}
        <div className="footer-content-wrapper">
          
          {/* Column 1: Brand & Overview */}
          <div className="footer-col footer-col-brand">
            <div className="footer-brand" onClick={handleNav('home')} style={{ cursor: 'pointer' }}>
              <img
                src={process.env.PUBLIC_URL + '/images/meena-logo.png'}
                alt="Meena Insurance & Investments"
                className="footer-brand-logo-img"
              />
            </div>

            <p className="footer-about-text">
              Personalized insurance and risk-management guidance for individuals, families, and
              businesses, helping you secure today and prosper tomorrow.
            </p>

            <div className="footer-social-links">
              <a href="#facebook" className="social-pill-btn" aria-label="Facebook">f</a>
              <a href="#twitter" className="social-pill-btn" aria-label="Twitter">𝕏</a>
              <a href="#linkedin" className="social-pill-btn" aria-label="LinkedIn">in</a>
              <a href="#pinterest" className="social-pill-btn" aria-label="Pinterest">P</a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-col footer-col-links">
            <h4 className="footer-col-title">QUICK LINKS</h4>
            <ul className="footer-nav-list">
              <li><a href="#home" onClick={handleNav('home')}>Home</a></li>
              <li><a href="#about" onClick={handleNav('home', 'about')}>About Me</a></li>
              <li><a href="#services" onClick={handleNav('home', 'solutions')}>Services</a></li>
              <li><a href="#contact" onClick={handleNav('contact')}>Contact</a></li>
            </ul>
          </div>

          {/* Column 3: Our Services */}
          <div className="footer-col footer-col-links">
            <h4 className="footer-col-title">OUR SERVICES</h4>
            <ul className="footer-nav-list">
              <li><a href="#solutions" onClick={handleNav('home', 'solutions')}>Family &amp; Individual Solutions</a></li>
              <li><a href="#solutions" onClick={handleNav('home', 'solutions')}>MSME &amp; Corporate Insurance</a></li>
              <li><a href="#solutions" onClick={handleNav('home', 'solutions')}>Policy Servicing</a></li>
              <li><a href="#solutions" onClick={handleNav('home', 'solutions')}>Risk Management</a></li>
            </ul>
          </div>

          {/* Column 4: Get in Touch */}
          <div className="footer-col footer-col-contact">
            <h4 className="footer-col-title">GET IN TOUCH</h4>
            <p className="footer-touch-desc">
              Have questions about your insurance or financial protection? Connect with Meena for
              personalized guidance.
            </p>

            <a
              href="#contact"
              className="btn-footer-consult"
              onClick={handleNav('contact')}
            >
              <span>Book a Consultation</span>
              <ArrowRight size={18} className="btn-arrow" />
            </a>

            <div className="footer-direct-contact-list">
              <a href="mailto:meenalic50@gmail.com" className="footer-contact-link-item">
                <Mail size={15} className="footer-contact-icon" />
                <span>meenalic50@gmail.com</span>
              </a>

              <a href="tel:+919710506057" className="footer-contact-link-item">
                <Phone size={15} className="footer-contact-icon" />
                <span>+91 9710506057</span>
              </a>

              <div className="footer-contact-address-item">
                <MapPin size={15} className="footer-contact-icon" style={{ marginTop: '3px' }} />
                <span>No. 986, 67th Street, 11th Sector, KK Nagar, Chennai – 600078</span>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar: Copyright & Legal */}
        <div className="footer-bottom-bar">
          <div className="footer-bottom-inner">
            <p className="footer-copyright">
              © Meena Insurance &amp; Investments. All Rights Reserved.
            </p>
            <div className="footer-legal-links">
              <a href="#privacy" className="legal-link" onClick={(e) => e.preventDefault()}>
                Privacy Policy
              </a>
              <span className="legal-divider">|</span>
              <a href="#terms" className="legal-link" onClick={(e) => e.preventDefault()}>
                Terms &amp; Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
